import React, { PureComponent } from 'react';
import {
  WithStyles,
  createStyles,
  withStyles,
} from '@lifeomic/chroma-react/styles';
import { injectIntl, defineMessages, WrappedComponentProps } from 'react-intl';
import Survey from '../util/Survey';
import { Text } from '@lifeomic/chroma-react/components/Text';
import { IconButton } from '@lifeomic/chroma-react/components/IconButton';
import { X } from '@lifeomic/chromicons';
import withIsMobile, {
  WithIsMobileInjectedProps,
} from '../../../hoc/withIsMobile';
import SurveyProgress from './SurveyProgress';

const styles = () =>
  createStyles({
    headerContainer: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    headerLeftContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      justifyContent: 'space-between',
    },
    progressContainer: {
      minWidth: 100,
    },
    surveyProgress: {
      float: 'right',
    },
  });

const messages = defineMessages({
  close: {
    id: 'surveyHeader.close',
    defaultMessage: 'Close',
  },
});

export interface SurveyHeaderOwnProps {
  onClose?: () => void;
  survey: Survey;
  currentPageLink: string;
  secondaryTitle?: string;
}

export type SurveyHeaderProps = SurveyHeaderOwnProps &
  WithStyles<typeof styles> &
  WrappedComponentProps &
  WithIsMobileInjectedProps;

class SurveyHeader extends PureComponent<SurveyHeaderProps> {
  getSecondaryTitleComponent() {
    const secondaryTitle =
      this.props.secondaryTitle || this.props.survey.description;

    if (!secondaryTitle) return null;

    return <Text size="subbody">{secondaryTitle}</Text>;
  }

  render() {
    const {
      classes,
      onClose,
      isMobile,
      survey,
      currentPageLink,
      intl: { formatMessage },
    } = this.props;

    if (isMobile) return null;

    return (
      <div className={classes.headerContainer}>
        <div>{this.getSecondaryTitleComponent()}</div>
        <div className={classes.headerLeftContainer}>
          <div>
            {onClose && (
              <IconButton
                aria-label={formatMessage(messages.close)}
                icon={X}
                size={0}
                onClick={onClose}
              />
            )}
          </div>
          <div className={classes.progressContainer}>
            <SurveyProgress
              survey={survey}
              currentPageLink={currentPageLink}
              variant="pill"
              className={classes.surveyProgress}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(injectIntl(withIsMobile(SurveyHeader)));
